import { useEffect, useMemo } from "react";
import useLocalStorage from "~/hooks/useLocalStorage";
export const ArgoInstancePageViewedKey = "Octopus.Argo.InstancePageViewed";
export function useArgoIsNew() {
    const hideAfter = new Date(2026, 1, 28);
    const showForDays = 30;
    const [firstSeen, setLocalStorage] = useLocalStorage<Date | undefined>("Octopus.Argo.FirstSeen", undefined);
    const [argoInstancePageViewed, setArgoInstancePageViewed] = useLocalStorage<boolean>(ArgoInstancePageViewedKey, false);
    const now = new Date(Date.now());
    useEffect(() => {
        if (firstSeen === undefined) {
            setLocalStorage(now);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return useMemo(() => {
        if (argoInstancePageViewed) {
            return false;
        }
        if (now > hideAfter) {
            return false;
        }
        if (firstSeen !== undefined) {
            const daysSinceFirstSeen = now.getDate() - new Date(firstSeen).getDate();
            return showForDays >= daysSinceFirstSeen;
        }
        return true;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [firstSeen]);
}
export function useArgoPageViewed() {
    return useLocalStorage<boolean>(ArgoInstancePageViewedKey, false);
}
